import { Link } from 'react-router-dom';
import { heroManhua } from '@/mocks/homeData';

export default function HeroBanner() {
  return (
    <section
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
      aria-label="首页英雄区"
    >
      <div className="absolute inset-0">
        <img
          src={heroManhua.imageUrl}
          alt="虚空韩漫网 - 韩漫在线阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-xl">
            <span className="inline-block px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-5">
              {heroManhua.subtitle}
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              {heroManhua.title}
            </h1>
            <p className="text-background-300/90 text-sm md:text-base leading-relaxed mb-6 max-w-md">
              {heroManhua.description}
            </p>
            <div className="flex flex-wrap items-center gap-3 mb-8">
              <span className="text-background-300 text-xs">
                <i className="ri-user-line mr-1"></i>
                {heroManhua.author}
              </span>
              <span className="w-1 h-1 rounded-full bg-background-500"></span>
              <span className="text-background-300 text-xs">
                <i className="ri-price-tag-3-line mr-1"></i>
                {heroManhua.genre}
              </span>
              <span className="w-1 h-1 rounded-full bg-background-500"></span>
              <span className="text-accent-400 text-xs font-medium">
                <i className="ri-star-fill mr-1"></i>
                {heroManhua.rating}
              </span>
              <span className="w-1 h-1 rounded-full bg-background-500"></span>
              <span className="text-background-300 text-xs">
                <i className="ri-eye-line mr-1"></i>
                {heroManhua.views}
              </span>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/manhua/1"
                className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-base"></i>
                开始阅读
              </Link>
              <Link
                to="/category/all"
                className="px-6 py-3 rounded-lg border border-background-400/50 text-background-200 text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-grid-line text-base"></i>
                浏览全部漫画
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}